const privacyContent = [
    {
        id: 1,
        title: 'Information We Collect',
        content: `We collect the following types of information when you use our website and services:

        Personal Information: This includes your name, contact details (such as email address, phone number), and delivery address.
        
        Payment Information: We collect payment details, including credit/debit card numbers or other financial information, necessary for processing your orders and payments securely.
        
        Order Information: We gather data about your orders, preferences, and purchase history to enhance your experience and improve our services.
        
        Device and Usage Information: We automatically collect information about your device, browser type, IP address, and usage patterns on our website to optimize your browsing experience and troubleshoot technical issues.`
    },
    {
        id: 2,
        title: 'How We Use Your Information',
        content: `We use your personal information for the following purposes:

        Order Fulfillment: To process and deliver your orders accurately and efficiently.
        
        Customer Support: To respond to your inquiries, requests, and provide assistance when needed.
        
        Improvement of Services: We analyze your usage patterns and feedback to enhance our website, services, and offerings.
        
        Marketing: With your consent, we may send you promotional emails, newsletters, and updates about our products and special offers.
        
        Security and Fraud Prevention: We use your information to monitor and prevent fraudulent activities, ensuring the security of your transactions.`
    },
    {
        id: 3,
        title: ' Information Sharing and Disclosure',
        content: `We do not sell, trade, or rent your personal information to third parties. However, we may share your information with:

        Service Providers: We may share your information with trusted third-party service providers who help us deliver our services, process payments, and maintain our website's functionality.
        
        Legal Compliance: We may disclose your information when required by law or to protect our rights, privacy, safety, or property.`
    },
    {
        id: 4,
        title: 'Your Choices',
        content: `Opt-Out: You can unsubscribe from marketing communications at any time by following the instructions provided in our emails or contacting us directly.

        Access and Update: You can access and update your personal information by logging into your account on our website.
        
        Delete Account: If you wish to delete your account, please contact us at [email address] with your request. Please note that certain information may be retained for legal and business purposes.`
    },
    {
        id: 5,
        title: 'Data Security',
        content: `We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, or alteration. However, no data transmission over the internet can be guaranteed to be 100% secure. Therefore, while we strive to protect your information, we cannot guarantee its absolute security.`
    },
    {
        id: 3,
        title: `Children's Privacy`,
        content: `Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from minors. If you are a parent or guardian and believe that your child has provided us with their information, please contact us.`
    },
    {
        id: 3,
        title: 'Changes to this Privacy Policy',
        content: `We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any significant changes by posting a prominent notice on our website or sending you an email.`
    },

]

export default privacyContent;